import { Transform } from "class-transformer";

export const TransformToEntityReference = () =>
  Transform(({ value }) =>
    value && value.length && typeof value[0] === "string" ? value.map((id: string) => ({ id })) : value
  );
